import { render, staticRenderFns } from "./IndividualResponseTotals.vue?vue&type=template&id=5f53d6f8"
import script from "./IndividualResponseTotals.vue?vue&type=script&lang=ts"
export * from "./IndividualResponseTotals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports